import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// ES
import esCommon from './locales/es/common.json';
import esLanding from './locales/es/landing.json';
import esRegistration from './locales/es/registration.json';
import esTrivia from './locales/es/trivia.json';
import esResult from './locales/es/result.json';
import esTerms from './locales/es/terms.json';

// EN
import enCommon from './locales/en/common.json';
import enLanding from './locales/en/landing.json';
import enRegistration from './locales/en/registration.json';
import enTrivia from './locales/en/trivia.json';
import enResult from './locales/en/result.json';
import enTerms from './locales/en/terms.json';

// DE
import deCommon from './locales/de/common.json';
import deLanding from './locales/de/landing.json';
import deRegistration from './locales/de/registration.json';
import deTrivia from './locales/de/trivia.json';
import deResult from './locales/de/result.json';
import deTerms from './locales/de/terms.json';

export const SUPPORTED_LANGUAGES = ['en', 'es', 'de'] as const;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        common: esCommon,
        landing: esLanding,
        registration: esRegistration,
        trivia: esTrivia,
        result: esResult,
        terms: esTerms,
      },
      en: {
        common: enCommon,
        landing: enLanding,
        registration: enRegistration,
        trivia: enTrivia,
        result: enResult,
        terms: enTerms,
      },
      de: {
        common: deCommon,
        landing: deLanding,
        registration: deRegistration,
        trivia: deTrivia,
        result: deResult,
        terms: deTerms,
      },
    },
    // English is the default: any browser language outside the supported set
    // falls back to English.
    fallbackLng: 'en',
    // Only these three languages are served; requests for anything else
    // (fr, it, pt, ja, ...) resolve to fallbackLng.
    supportedLngs: [...SUPPORTED_LANGUAGES],
    // Map regional variants to their base language (de-DE -> de, en-GB -> en,
    // es-419 -> es) so browser locales resolve correctly.
    load: 'languageOnly',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['navigator'],
    },
  });

// Keep the <html lang> attribute in sync with the active language for
// accessibility and SEO.
const syncHtmlLang = (lng: string) => {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = lng;
  }
};
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

// Dev-only: expose the i18n instance for manual QA of each language in the
// browser. Never exposed in production builds.
if (process.env.NODE_ENV !== 'production') {
  (window as any).i18n = i18n;
}

export default i18n;
